import { render } from "./VabeneTransactionDetailsPage.vue?vue&type=template&id=05cc3dc7&ts=true"
import script from "./VabeneTransactionDetailsPage.vue?vue&type=script&lang=ts"
export * from "./VabeneTransactionDetailsPage.vue?vue&type=script&lang=ts"

import exportComponent from "../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__